'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _languageHandler = require('../../../languageHandler');

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _TagOrderActions = require('../../../actions/TagOrderActions');

var _TagOrderActions2 = _interopRequireDefault(_TagOrderActions);

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TagTileContextMenu = function (_React$Component) {
    (0, _inherits3.default)(TagTileContextMenu, _React$Component);

    function TagTileContextMenu() {
        (0, _classCallCheck3.default)(this, TagTileContextMenu);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TagTileContextMenu.__proto__ || (0, _getPrototypeOf2.default)(TagTileContextMenu)).call(this));

        _this._onViewCommunityClick = _this._onViewCommunityClick.bind(_this);
        _this._onRemoveClick = _this._onRemoveClick.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(TagTileContextMenu, [{
        key: '_onViewCommunityClick',
        value: function _onViewCommunityClick() {
            _dispatcher2.default.dispatch({
                action: 'view_group',
                group_id: this.props.tag
            });
            this.props.onFinished();
        }
    }, {
        key: '_onRemoveClick',
        value: function _onRemoveClick() {
            _dispatcher2.default.dispatch(_TagOrderActions2.default.removeTag(
            // XXX: Context menus don't have a MatrixClient context
            _MatrixClientPeg2.default.get(), this.props.tag));
            this.props.onFinished();
        }
    }, {
        key: 'render',
        value: function render() {
            var TintableSvg = _index2.default.getComponent("elements.TintableSvg");
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'mx_TagTileContextMenu_item', onClick: this._onViewCommunityClick },
                    _react2.default.createElement(TintableSvg, {
                        className: 'mx_TagTileContextMenu_item_icon',
                        src: require("../../../../res/img/icons-groups.svg"),
                        width: '15',
                        height: '15'
                    }),
                    (0, _languageHandler._t)('View Community')
                ),
                _react2.default.createElement('hr', { className: 'mx_TagTileContextMenu_separator' }),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_TagTileContextMenu_item', onClick: this._onRemoveClick },
                    _react2.default.createElement('img', { className: 'mx_TagTileContextMenu_item_icon', src: require("../../../../res/img/icon_context_delete.svg"), width: '15', height: '15' }),
                    (0, _languageHandler._t)('Hide')
                )
            );
        }
    }]);
    return TagTileContextMenu;
}(_react2.default.Component); /*
                              Copyright 2018 New Vector Ltd
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */

TagTileContextMenu.propTypes = {
    tag: _propTypes2.default.string.isRequired,
    /* callback called when the menu is dismissed */
    onFinished: _propTypes2.default.func.isRequired
};
exports.default = TagTileContextMenu;
module.exports = exports['default'];
//# sourceMappingURL=TagTileContextMenu.js.map